import type { ConditionalTile } from '~/contracts/srp';
import { isDefined } from '~/utilities/srp/array';
import getDownPaymentTile, {
  type OwnProps as DownPaymentTileProps
} from './getDownPaymentTile';
import getFinanceTile, {
  type OwnProps as FinanceTileProps
} from './getFinanceTile';
import getGreatDealTile, {
  type OwnProps as GreatDealTileProps
} from './getGreatDealTile';
import getSaveSearchTile, {
  type OwnProps as SaveSearchTileProps
} from './getSaveSearchTile';
import getTradeInTile, {
  type ExternalProps as TradeInTileProps
} from './getTradeInTile';

type OwnProps = DownPaymentTileProps &
  FinanceTileProps &
  GreatDealTileProps &
  SaveSearchTileProps &
  TradeInTileProps;

export default function getConditionalTiles({
  device,
  filteredByMinDown,
  filters,
  hasActiveTrade,
  hasEligibleDownPaymentRange,
  hasPositiveEquityIfActiveTrade,
  hasSoftPull,
  pageNumber,
  showFinance
}: OwnProps): ConditionalTile[] {
  const financeTile = [
    getFinanceTile({ hasSoftPull, showFinance }),
    getDownPaymentTile({
      filteredByMinDown,
      hasEligibleDownPaymentRange,
      hasPositiveEquityIfActiveTrade,
      showFinance
    })
  ].find(v => v.active); // Only one of these tiles can be active at a time
  const greatDealTile = getGreatDealTile({ device, filters });
  const saveSearchTile = getSaveSearchTile({ filters });
  const tradeInTile = getTradeInTile({
    hasActiveTrade,
    isShowingSaveSearch: saveSearchTile.active,
    pageNumber
  });

  return [financeTile, greatDealTile, saveSearchTile, tradeInTile].filter(
    isDefined
  );
}
